import TagManager from 'react-gtm-module';

export function initializeGTM(): void {
  TagManager.initialize({
    gtmId: window.configs.gtmId,
  });
}

export function logPageView(): void {
  TagManager.dataLayer({
    dataLayer: {
      event: 'pageview',
    },
  });
}
